import React from "react";

const SvgArrowLeft = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="25" height="25" fill="#C299F5" fillOpacity="0.01" />
    <circle cx="12.5" cy="12.5" r="12.5" fill="#B496FC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3962 7.26007C15.7013 7.56517 15.7013 8.05983 15.3962 8.36493L11.2611 12.5L15.3962 16.6351C15.7013 16.9402 15.7013 17.4348 15.3962 17.7399C15.0911 18.045 14.5964 18.045 14.2913 17.7399L9.60382 13.0524C9.29873 12.7473 9.29873 12.2527 9.60382 11.9476L14.2913 7.26007C14.5964 6.95498 15.0911 6.95498 15.3962 7.26007Z"
      fill="white"
    />
  </svg>
);

export default SvgArrowLeft;
